import { store } from "../../store";
import { setMarkedNotification, clearMarkedNotification } from "../reducers/notifications.reducers";

const dispatch = store.dispatch

export function setMarkNotification(notification) {
  dispatch(setMarkedNotification(notification));
}

export function clearNotification() {
  dispatch(clearMarkedNotification())
}
